import React, { useState } from 'react';
import {Button, Checkbox, Divider, Form, Input, InputNumber, Modal} from 'antd';
import UserSearchSelect, { UserValue } from '../../common/selector/UserSearchSelect';
import { CreateCashTxType } from '../../../stores/cashTxStore';
import CashDescription from '../CashDescription/CashDescription';
import {Cash} from "../../../types/Cash";
import constants from "../../../constants";

interface CashMakeRequestPopupProps {
	isModalOpen?: boolean,
	onSubmit?: (values: CreateCashTxType) => void,
	onClose?: (e: any) => void,
	selectedAction?: 'deposit' | 'withdrawal';
}

const CashMakeRequestPopup = ({
	                              isModalOpen,
	                              onSubmit,
	                              onClose,
	                              selectedAction
                              }: CashMakeRequestPopupProps) => {
	const [userAvailableCash, setUserAvailableCash] = useState(0);
	const [isButtonDisabled, setIsButtonDisabled] = useState(false);
	const [selectedUser, setSelectedUser] = useState<UserValue>({
		key: '',
		label: '',
		value: '',
		phoneNum: ''
	} as UserValue);
	const [isFirstBalju, setIsFirstBalju] = useState(false);

	const title = (selectedAction === 'deposit') ? '충전 생성' : '출금 생성';

	const [form] = Form.useForm();
	const formItemLayout = {
		labelCol: {
			xs: { span: 24 },
			sm: { span: 4 },  // 레이블의 폭 조정 (기본 8을 줄여봄)
		},
		wrapperCol: {
			xs: { span: 24 },
			sm: { span: 18 },  // 입력 필드의 폭 조정
		},
	};

	const handleValuesChange = (_changedValues: any, allValues: CreateCashTxType) => {
		// 출금이고 출금가능액보다 인출요청금액이 크면 버튼 disabled 처리
		if (selectedAction === 'withdrawal') {
			const amount = allValues.amount || 0;
			setIsButtonDisabled(userAvailableCash < amount);
		}
	};

	const onCheck = (e: any) => {
		const checked = e.target.checked;
		setIsFirstBalju(checked);

		if (checked) {
			form.setFieldsValue({
				amount: 10000,
				reasonCode: constants.REASON_CODE_FIRST_BALJU,
			});
		} else {
			form.resetFields(['amount', 'reasonCode']);
		}
	}

	return (
		<Modal
			title={<span style={{ color: '#1677ff', fontSize: '1em'}}>{title}</span>}
			open={isModalOpen}
			onCancel={onClose}
			footer={null}
			width={500}  // 원하는 너비로 설정
			styles={{ body: { paddingBottom: 0 } }}  // 설정: 하단 패딩을 줄이기
		>
			<CashDescription
				userId={selectedUser.key}
				style={{ margin: '30px' }}
				onSelect={(cashData: Cash) => setUserAvailableCash(cashData.availableCash)}
			/>
			<Divider/>
			<Form
				{...formItemLayout}
				form={form}
				variant={'outlined'}
				size={'large'}
				onFinish={onSubmit}
				initialValues={{ variant: 'filled',  requestType: selectedAction }}
				onValuesChange={handleValuesChange}
				style={{ width: '100%', marginTop: '20px' }}
			>
				{selectedAction === 'deposit' && (
					<Form.Item name="reasonCode">
						<Checkbox checked={isFirstBalju} onChange={onCheck}>발주지원금 이벤트</Checkbox>
					</Form.Item>
				)}
				<Form.Item label="요청자" name="userId" rules={[{ required: true, message: '사용자를 선택하세요.' }]}>
					<UserSearchSelect
						selectedUser={selectedUser}
						onChange={ async (value) => {
							if (!value || !value.key) return;
							setSelectedUser(value);
							form.setFieldsValue({ userId: value.key });
						}}
					/>
				</Form.Item>
				<Form.Item name="requestType" noStyle>
					<Input type="hidden"/>
				</Form.Item>
				<Form.Item
					label="요청금액"
					name="amount"
					rules={[{ required: true, message: '금액을 입력하세요.' }]}
				>
					<InputNumber
						style={{ width: '100%' }}
						formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
						onChange={(value) => form.setFieldsValue({ amount: value })}
					/>
				</Form.Item>
				{(selectedAction && selectedAction === 'deposit') && (
					<Form.Item
						label="입금자명"
						name="accountName"
						rules={[{
							required: selectedAction && selectedAction === 'deposit',
							message: '입금자명을 입력하세요.',
						}]}
					>
						<Input type="text" />
					</Form.Item>
				)}
				<Form.Item
					label="사유"
					name="reason"
					rules={[{ required: true, message: '사유를 입력하세요.' }]}
				>
					<Input.TextArea />
				</Form.Item>
				{(selectedAction && selectedAction === 'withdrawal') ? (
					<div>
						<Form.Item
							label="은행명"
							name="accountBank"
							rules={[{ required: true, message: '은행명을 입력하세요.' }]}
						>
							<Input type="text" />
						</Form.Item>
						<Form.Item
							label="계좌번호"
							name="accountNumber"
							rules={[{ required: true, message: '계좌번호을 입력하세요.' }]}
						>
							<InputNumber style={{ width: '100%' }}/>
						</Form.Item>
						<Form.Item
							label="예금주"
							name="accountName"
							rules={[{ required: true, message: '예금주를 입력하세요.' }]}
						>
							<Input type="text" />
						</Form.Item>
					</div>
				) : <div/> }
				<Form.Item style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '50px' }} label={null}>
					<Button
						type="primary"
						size="middle"
						htmlType="submit"
						disabled={isButtonDisabled}
					>
						만들기
					</Button>
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default CashMakeRequestPopup;
